<panel *ngIf="!selected.invoice && (!loading || !partners.empty)">

  <div header>
    <span [ngClass]="{'text-primary pointer': selected.partner}" (click)="select(null)">{{'Đơn xuất hàng' | lang}} ({{configs.invoiceResolvableDays}} {{'ngày' | lang}})</span>
    <ng-container *ngIf="selected.partner">
      <span class="hlf-margin-left hlf-margin-right">|</span>
      <span>{{selected.partner.Name}}</span>
    </ng-container>
  </div>

  <div class="flex" right *ngIf="selected.partner">
    <text-filter [target]="invoices" [placeholder]="'Tìm đơn hàng'"></text-filter>
    <button class="bg-warning text-white hlf-margin-left pointer" (click)="create()" *ngIf="selected.partner.ID > 0"><i class="fa fa-plus"></i></button>
  </div>

  <text-filter right *ngIf="!selected.partner" [target]="partners" [placeholder]="'Tìm khách hàng'"></text-filter>

  <table responsive class="data hover" *ngIf="!selected.partner">
    <tr>
      <th priority="8" class="text-top text-right" style="width: 0">{{'STT' | lang}}</th>
      <th priority="1"><sortable [target]="partners" [extractor]="extractor('Partner')" [selected]="all.EditableCount + all.ConfirmedCount < 1">{{'Khách hàng' | lang}}</sortable></th>
      <th priority="4" class="text-right"><sortable [target]="partners" [extractor]="extractor('ConfirmedStamp')" [selected]="all.EditableCount < 1 && all.ConfirmedCount > 0" [sort]="'descending'">{{'Đơn xong' | lang}}</sortable></th>
      <th priority="3" class="text-right"><sortable [target]="partners" [selected]="all.EditableCount > 0" [sort]="'descending'" [extractor]="extractor('EditableStamp')">{{'Đơn chờ' | lang}}</sortable></th>
      <th priority="5" class="text-right"><sortable [target]="partners" [extractor]="extractor('Count')">{{'Số cây' | lang}}</sortable></th>
      <th priority="7" class="text-right"><sortable [target]="partners" [extractor]="extractor('LengthActualQuantity')">{{'Tổng mét' | lang}}</sortable></th>
      <th priority="7" class="text-right"><sortable [target]="partners" [extractor]="extractor('WeightActualQuantity')">{{'Tổng cân' | lang}}</sortable></th>
      <th priority="6" class="text-right"><sortable [target]="partners" [extractor]="extractor('Total')">{{'Tổng tiền' | lang}}</sortable></th>
      <th priority="2" class="text-left" style="width: 0"></th>
    </tr>

    <tr *ngFor="let i of partners.pageMatches; index as ix">
      <td><small>{{ ix + 1 + partners.pageIndex * partners.pageSize}}</small></td>
      <td class="pointer" (click)="select(i)">
        <b class="uppercase bold text-primary">{{i.partner.Name}}</b>
        <div class="small spacy">K{{i.partner.ID}}</div>
      </td>
      <td class="pointer" (click)="select(i)">
        <span class="text-success">{{i.ConfirmedCount | number : '1.0-0' : 'en-US'}}</span><unit>{{'đơn' | lang}}</unit>
        <div class="small" *ngIf="i.ConfirmedCount > 0">{{i.ConfirmedStamp | date : 'dd-MM-yyyy'}}</div>
      </td>
      <td class="pointer" (click)="select(i)">
        <span class="text-warning">{{i.EditableCount | number : '1.0-0' : 'en-US'}}</span><unit>{{'đơn' | lang}}</unit>
        <div class="small" *ngIf="i.EditableCount > 0">{{i.EditableStamp | date : 'dd-MM-yyyy'}}</div>
      </td>
      <td class="pointer" (click)="select(i)">
        {{i.LengthCount + i.WeightCount | number : '1.0-0' : 'en-US'}}<unit>{{'cây' | lang}}</unit>
      </td>
      <td class="pointer" (click)="select(i)">
        {{i.LengthActualQuantity | number : '1.1-1' : 'en-US'}}<m></m>
      </td>
      <td class="pointer" (click)="select(i)">
        {{i.WeightActualQuantity | number : '1.1-1' : 'en-US'}}<kg></kg>
      </td>
      <td class="pointer" (click)="select(i)">
        <span class="bold text-success">{{i.Total | number : '1.0-0' : 'en-US'}}</span><vnd></vnd>
      </td>
      <td class="pointer" (click)="select(i); create()">
        <i class="fa fa-plus text-warning std-margin-left std-margin-right"></i>
      </td>
    </tr>
    <tr *ngIf="partners.pages.length > 1" [ngClass]="{'footer': partners.matches.length < partners.source.length}">
      <td style="display: none"></td>
      <td [colSpan]="9" style="display: table-cell !important; z-index: unset" class="text-center"><pagination [target]="partners"></pagination></td>
    </tr>
    <tr class="footer pointer bold text-primary" *ngIf="partners.matches.length == partners.source.length" (click)="select(all)">
      <td>
        <i class="fa fa-info-circle"></i>
      </td>
      <td>
        <b class="uppercase">{{all.partner.Name}}</b>
      </td>
      <td>
        <span>{{all.ConfirmedCount | number : '1.0-0' : 'en-US'}}</span><unit>{{'đơn' | lang}}</unit>
      </td>
      <td>
        <span>{{all.EditableCount | number : '1.0-0' : 'en-US'}}</span><unit>{{'đơn' | lang}}</unit>
      </td>
      <td>
        {{all.LengthCount + all.WeightCount | number : '1.0-0' : 'en-US'}}<unit>{{'cây' | lang}}</unit>
      </td>
      <td>
        {{all.LengthActualQuantity | number : '1.1-1' : 'en-US'}}<m></m>
      </td>
      <td>
        {{all.WeightActualQuantity | number : '1.1-1' : 'en-US'}}<kg></kg>
      </td>
      <td>
        <span>{{all.Total | number : '1.0-0' : 'en-US'}}</span><vnd></vnd>
      </td>
      <td></td>
    </tr>
  </table>

  <table responsive class="data hover" *ngIf="selected.partner">
    <tr>
      <th priority="8" class="text-top text-right" style="width: 0">STT</th>
      <th priority="4" class="text-top text-left nowrap"><sortable [target]="invoices" [extractor]="extractor('Stamp')" [selected]="true" [sort]="'descending'">{{'Ngày' | lang}}</sortable></th>
      <th priority="1" class="text-top text-center"><sortable [target]="invoices" [extractor]="extractor('ID')">{{'Mã đơn' | lang}}</sortable></th>
      <th priority="3" class="text-top text-center"><sortable [target]="invoices" [extractor]="extractor('State')">{{'Trạng thái' | lang}}</sortable></th>
      <th priority="7" class="text-top text-right"><sortable [target]="invoices" [extractor]="extractor('SKUCount')">{{'Mặt hàng' | lang}}</sortable></th>
      <th priority="5" class="text-top text-right"><sortable [target]="invoices" [extractor]="extractor('Count')">{{'Số cây' | lang}}</sortable></th>
      <th priority="6" class="text-top text-right"><sortable [target]="invoices" [extractor]="extractor('LengthQuoteQuantity')">{{'Số mét' | lang}}</sortable></th>
      <th priority="7" class="text-top text-right"><sortable [target]="invoices" [extractor]="extractor('WeightQuoteQuantity')">{{'Số cân' | lang}}</sortable></th>
      <th priority="2" class="text-top text-right"><sortable [target]="invoices" [extractor]="extractor('Total')">{{'Tổng tiền' | lang}}</sortable></th>
    </tr>

    <tr *ngFor="let i of invoices.pageMatches; index as ix" class="pointer" (click)="open(i)">
      <td><small>{{ix + 1 + invoices.pageIndex * invoices.pageSize}}</small></td>
      <td>{{i.Stamp | date : 'dd-MM-yyyy'}}</td>
      <td>
        <div class="spacy text-success bold">{{i.Tag}}</div>
        <div class="small uppercase" *ngIf="selected.partner.ID < 1">{{partner(i).Name}}</div>
      </td>
      <td class="uppercase small nowrap" [ngClass]="{'text-warning': i.State == 1, 'text-success': i.State == 2}">{{state(i) | lang}}</td>
      <td>{{i.SKUCount | number : '1.0-0' : 'en-US'}}</td>
      <td>{{i.LengthCount + i.WeightCount | number : '1.0-0' : 'en-US'}}<unit>{{'cây' | lang}}</unit></td>
      <td>{{i.LengthQuoteQuantity | number : '1.1-1' : 'en-US'}}<m></m></td>
      <td>{{i.WeightQuoteQuantity | number : '1.1-1' : 'en-US'}}<kg></kg></td>
      <td><span class="text-success">{{i.Total | number : '1.0-2' : 'en-US'}}</span><unit>{{i.Icon}}</unit></td>
    </tr>
    <tr class="footer" *ngIf="invoices.pages.length > 1">
      <td [colSpan]="9" class="text-center" style="display: table-cell !important"><pagination [target]="invoices"></pagination></td>
    </tr>
  </table>

</panel>

<div class="flex col w-100 container" *ngIf="selected.invoice">

  <div class="scrollable-x" #scrollableX>

    <div class="flex row">

      <panel [header]="false" class="editor">
        <div class="flex col">

          <div *ngIf="selected.invoice" class="flex space-between items-center header">
            <div class="bold uppercase">{{'Đơn xuất hàng' | lang}} {{selected.invoice.Tag}} {{'tới' | lang}} {{selected.partner.Name}} (<span [ngClass]="{'text-primary pointer':  editable}" (click)="editStamp()">{{selected.invoice.Stamp | date : 'dd-MM-yyyy'}}</span>)</div>
            <small class="button uppercase" (click)="close()">{{'Đóng đơn' | lang}}</small>
          </div>

          <div class="flex row">

            <div class="scrollable-y" #scrollableLeft>

              <table responsive class="data hover" *ngIf="selected.invoice">
                <tr>
                  <th priority="1" class="text-top text-left">{{'Mã hàng' | lang}}</th>
                  <th priority="1" class="text-top text-center">{{'Màu' | lang}}</th>
                  <th priority="1" class="text-top text-center">{{'Số cây' | lang}}</th>
                  <th priority="3" class="text-top text-left">{{'Dài / nặng từng cây' | lang}}</th>
                  <th priority="2" class="text-bottom text-right">{{'Tổng dài' | lang}}</th>
                  <th priority="1" class="text-bottom text-right">{{'Khấu trừ' | lang}}</th>
                  <th priority="1" class="text-bottom text-right">{{'Tính tiền' | lang}}</th>
                  <th priority="1" class="text-bottom text-right">{{'Giá bán' | lang}}</th>
                  <th priority="1" class="text-bottom text-right">{{'Thành tiền' | lang}}</th>

                </tr>
                <tr *ngFor="let i of selected.details.matches">
                  <td>
                    <good class="bold spacy nowrap text-primary" [sku]="i.SKU"></good>
                    <div class="small spacy nowrap">{{i.ImportInvoiceTag}}</div>
                    <div class="small spacy nowrap">{{source(i.ImportInvoiceTag)}}</div>
                  </td>
                  <td>{{i.Color}}</td>
                  <td class="bold">{{i.records.length | number : '1.0-0' : 'en-US'}}</td>
                  <td>
                    <div class="flex inputs">
                      <span *ngFor="let o of i.records">{{o.ActualQuantity | number : '1.1-1' : 'en-US'}} <i *ngIf="editable" class="small fa fa-times hlf-margin-left pointer text-danger" (click)="remove(o)"></i></span>
                    </div>
                  </td>
                  <td>
                    <b>{{group.actualQuantity(i) | number : '1.0-2' : 'en-US'}}</b><product-unit [type]="i.Unit"></product-unit>
                  </td>
                  <td class="bold">
                    <b>{{group.actualQuantity(i) - group.quoteQuantity(i) | number : '1.1-1' : 'en-US'}}</b><product-unit [type]="i.Unit"></product-unit>
                  <td>
                    <b>{{group.quoteQuantity(i) | number : '1.1-1' : 'en-US'}}</b><product-unit [type]="i.Unit"></product-unit>
                  </td>
                  <td class="nowrap">
                    <number-input *ngIf="i.records[0].IsPriceEditable && editable" [value]="group.quoteUnitPrice(i)" (change)="editPrice(i, $event.target)" [fit]="true" [decimalPlaces]="0" class="text-primary bold"></number-input>
                    <b *ngIf="!i.records[0].IsPriceEditable || !editable">{{group.quoteUnitPrice(i) | number : '1.0-2' : 'en-US'}}</b>                    
                    <symbol-per-unit [symbol]="selected.invoice.Icon" [type]="i.Unit"></symbol-per-unit>
                  </td>
                  <td>
                    <b class="text-success">{{group.subtotal(i) | number : '1.0-2' : 'en-US'}}</b><unit>{{selected.invoice.Icon}}</unit>
                  </td>
                </tr>

                <tr class="bold nowrap" *ngIf="group.sum('Count', 1) * group.sum('Count', 2) > 0">
                  <td>
                    <div>{{'TỔNG MÉT' | lang}}</div>
                    <div>{{'TỔNG CÂN' | lang}}</div>
                  </td>
                  <td></td>
                  <td>
                    <div>{{group.sum('Count', 1) | number : '1.0-0' : 'en-US'}}</div>
                    <div>{{group.sum('Count', 2) | number : '1.0-0' : 'en-US'}}</div>
                  </td>
                  <td></td>
                  <td>
                    <div>{{group.sum('ActualQuantity', 1) | number : '1.1-1' : 'en-US'}}<m></m></div>
                    <div>{{group.sum('ActualQuantity', 2) | number : '1.1-1' : 'en-US'}}<kg></kg></div>
                  </td>
                  <td>
                    <div>{{group.sum('Reduced', 1) | number : '1.1-1' : 'en-US'}}<m></m></div>
                    <div>{{group.sum('Reduced', 2) | number : '1.1-1' : 'en-US'}}<kg></kg></div>
                  </td>
                  <td>
                    <div>{{group.sum('QuoteQuantity', 1) | number : '1.1-1' : 'en-US'}}<m></m></div>
                    <div>{{group.sum('QuoteQuantity', 2) | number : '1.1-1' : 'en-US'}}<kg></kg></div>
                  </td>
                  <td></td>
                  <td>
                    <div>{{group.sum('Subtotal', 1) | number : '1.0-0' : 'en-US'}}<unit>{{selected.invoice.Icon}}</unit></div>
                    <div>{{group.sum('Subtotal', 2) | number : '1.0-0' : 'en-US'}}<unit>{{selected.invoice.Icon}}</unit></div>
                  </td>
                </tr>

                <tr class="footer bold text-primary nowrap" *ngIf="!selected.details.empty">
                  <td>{{'TỔNG ĐƠN' | lang}}</td>
                  <td></td>
                  <td>                                       
                    <div>{{group.sum('Count') | number : '1.0-0' : 'en-US'}}</div>
                  </td>
                  <td></td>
                  <td>
                    <div>
                      <span>{{group.sum('ActualQuantity') | number : '1.1-1' : 'en-US'}}</span>
                      <m *ngIf="group.sum('Count', 2) < 1 && group.sum('Count', 1) > 0"></m>
                      <kg *ngIf="group.sum('Count', 1) < 1 && group.sum('Count', 2) > 0"></kg>
                      <unit *ngIf="group.sum('Count', 1) * group.sum('Count', 2) > 0">đv</unit>
                    </div>
                  </td>
                  <td>
                    <span>{{group.sum('Reduced') | number : '1.1-1' : 'en-US'}}</span>
                    <m *ngIf="group.sum('Count', 2) < 1 && group.sum('Count', 1) > 0"></m>
                    <kg *ngIf="group.sum('Count', 1) < 1 && group.sum('Count', 2) > 0"></kg>
                    <unit *ngIf="group.sum('Count', 1) * group.sum('Count', 2) > 0">đv</unit>
                  </td>
                  <td>
                    <span>{{group.sum('QuoteQuantity') | number : '1.1-1' : 'en-US'}}</span>
                    <m *ngIf="group.sum('Count', 2) < 1 && group.sum('Count', 1) > 0"></m>
                    <kg *ngIf="group.sum('Count', 1) < 1 && group.sum('Count', 2) > 0"></kg>
                    <unit *ngIf="group.sum('Count', 1) * group.sum('Count', 2) > 0">đv</unit>
                  </td>
                  <td></td>
                  <td>
                    <div>{{group.sum('Subtotal') | number : '1.0-2' : 'en-US'}}<unit>{{selected.invoice.Icon}}</unit></div>
                  </td>
                </tr>
              </table>

            </div>
            <scrollbar [target]="scrollableLeft"></scrollbar>

          </div>

          <div class="flex" *ngIf="selected.partner">
            <button *ngIf="savable" class="bg-success text-white" (click)="update()"><span>{{'Cập nhật đơn xuất hàng' | lang}}</span></button>
            <button *ngIf="confirmable" class="bg-success text-white" (click)="confirm()"><span>{{'Xác nhận xuất hàng' | lang}}</span></button>
            <button *ngIf="cancelable" class="bg-danger text-white" (click)="cancel()"><span>{{'Hủy đơn xuất hàng' | lang}}</span></button>
          </div>
        </div>
      </panel>

      <panel [header]="false" class="editor">

        <div class="flex col">

          <div class="header flex">
            <text-filter [placeholder]="'Tìm hàng'" [target]="goods"></text-filter>
            <button class="pointer text-white bg-warning hlf-margin-left" (click)="importData()"><i class="fa fa-file-excel"></i></button>
          </div>
          <div class="flex row">

            <div class="scrollable-y" #scrollableRight>

              <table class="data hover">
                <tr>
                  <th priority="1" class="text-left">Mã hàng</th>
                  <th priority="1" class="text-center">Màu</th>
                  <th priority="1" class="text-center">Dài / nặng</th>
                  <th priority="3" class="text-right">Giá nhập</th>
                  <th priority="2" class="text-right">Nguồn</th>
                </tr>
                <tr *ngFor="let i of goods.pageMatches" class="pointer" (click)="add(i)">
                  <td class="text-left"><good class="bold spacy nowrap" [sku]="i.SKU"></good></td>
                  <td class="text-center bold text-info">{{i.Color}}</td>
                  <td class="text-center">{{i.ActualQuantity}}<product-unit [type]="i.Unit"></product-unit></td>
                  <td class="text-right">
                    <span *ngIf="i.ImportUnitPrice > 0">
                      <b class="text-success">{{i.ImportUnitPrice | number : '1.0-2' : 'en-US'}}</b>
                      <symbol-per-unit [symbol]="i.ImportSymbol" [type]="i.Unit"></symbol-per-unit>
                    </span>
                    <small class="text-danger" *ngIf="i.ImportUnitPrice <= 0">chưa có giá</small>
                  </td>
                  <td class="text-right">
                    <div class="spacy small">{{i.ImportInvoiceTag}}</div>
                    <small>{{source(i.ImportInvoiceTag)}}</small>
                  </td>
                </tr>
                <tr class="footer" *ngIf="goods.pages.length > 1">
                  <td [colSpan]="5" class="text-center"><pagination [target]="goods"></pagination></td>
                </tr>
              </table>

            </div>

            <scrollbar [target]="scrollableRight"></scrollbar>
          </div>
        </div>

      </panel>

    </div>

  </div>

  <scrollbar class="bottom" [target]="scrollableX" *ngIf="selected.invoice"></scrollbar>

</div>


<ngx-loading [show]="loading" [config]="{fullScreenBackdrop: true}"></ngx-loading>
